import {
  Card,
  CardContent,
  CardHeader,
  InputAdornment,
  TextField,
} from "@mui/material"
import { DeviceConsumable } from "graphql/types"
import { normalizeNumberInput } from "utils/numberInputHelpers"

type AddCosumableCardProps = {
  newDevice: DeviceConsumable
  setNewDevice: (arg: DeviceConsumable) => void
}

export const AddConsumableCard = (props: AddCosumableCardProps) => {
  const { newDevice, setNewDevice } = props
  return (
    <Card>
      <CardHeader
        title={newDevice.name}
        slotProps={{ title: { variant: "body1" } }}
        sx={{ p: 0, pl: 1, pt: 1 }}
      />
      <CardContent sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
        <TextField
          size="small"
          fullWidth
          label="Menge"
          type="number"
          value={newDevice.amount || ""}
          slotProps={{
            input: {
              endAdornment: newDevice.unit && (
                <InputAdornment position="end">{newDevice.unit}</InputAdornment>
              ),
            },
          }}
          onChange={(e) => {
            const value = e.currentTarget.value
            if (value === "") {
              setNewDevice({
                ...newDevice,
                amount: 0, // Will show as empty due to || "" in value prop
              })
            } else {
              const numValue = parseFloat(value)
              setNewDevice({
                ...newDevice,
                amount: isNaN(numValue) ? 0 : numValue,
              })
            }
          }}
          onBlur={(e) => {
            const normalizedValue = normalizeNumberInput(e.currentTarget.value)
            if (normalizedValue !== newDevice.amount) {
              setNewDevice({
                ...newDevice,
                amount: normalizedValue,
              })
            }
          }}
        />
        <TextField
          size="small"
          fullWidth
          label="Charge"
          value={newDevice.charge}
          onChange={(e) => {
            setNewDevice({
              ...newDevice,
              charge: e.currentTarget.value,
            })
          }}
        />
      </CardContent>
    </Card>
  )
}
